import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flag-lesson-modal',
  templateUrl: './flag-lesson-modal.component.html',
  styleUrls: ['./flag-lesson-modal.component.scss']
})
export class FlagLessonModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
